"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@/api");
function switchProfile({ profileId, retryCount, onSuccess, onError, }) {
    return __awaiter(this, void 0, void 0, function* () {
        if (retryCount > 0) {
            const retryFunc = () => setTimeout(() => switchProfile({ profileId, retryCount: retryCount - 1, onSuccess, onError }), 1000);
            yield (0, api_1.postData)(`/api/v1/profile/auth/${profileId}/switch`, null)
                .then(res => {
                if (res.status === 200) {
                    onSuccess();
                }
                else {
                    retryFunc();
                }
            })
                .catch(retryFunc);
        }
        else {
            onError();
        }
    });
}
exports.default = switchProfile;
